import ShareExternalLink from "./SVG/share-external-link.svg?react";

const ShareExternalLinkIcon = () => {
  return <ShareExternalLink />;
};

export default ShareExternalLinkIcon;
